import React from 'react';
import cx from 'classnames';

class FreeformEmailInput extends React.Component {
  constructor() {
    super(...arguments);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(e) {
    this.props.onEmailChange(e.target.value);
  }

  render() {
    return (
      <div className="EmailInput">
        <div className="EmailInput__Freeform">
          <input
            className={cx({
              EmailInput__Input: true,
              'EmailInput__Input--invalid': this.props.invalid,
            })}
            value={this.props.email}
            onChange={this.handleInputChange}
          />
        </div>
      </div>
    );
  }
}

export default FreeformEmailInput;
